import 'intersection-observer'

/**
 * Function that triggers animations on scroll.
 */
export default function scroll () {
  const animTriggerClass = 'anim-enter-trigger'
  const animElems = document.querySelectorAll(
    // All columns:
    '[data-cols] > *,' +
    // All top-level elements except cols and groups:
    '.post-content > :not([data-type="core/columns"]):not([data-type="core/group"]),' +
    // All elements in a top-level group except other cols and groups:
    '.post-content > [data-type="core/group"] > * > :not([data-type="core/columns"]):not([data-type="core/group"])'
  )

  // Observer options.
  const options = {
    root: null,
    rootMargin: '0px',
    thresholds: [0, 0.5, 1],
  }

  const io = new IntersectionObserver(
    entries => {
      entries.forEach( entry => {
        if ( entry.isIntersecting || entry.intersectionRatio > 0 ) {
          entry.target.classList.add( animTriggerClass )
          io.unobserve( entry.target )
        }
      })

    },
    options
  )

  Array.from( animElems ).forEach( element => {
    io.observe( element )

    /**
     * Remove the transform property of all animations when the animation ends.
     * This allows the video modal to open on full screen when the Video
     * block is added inside the Column core block.
     * Solves the bug GCC-372.
     */
    element.addEventListener( 'transitionend', () => {
      element.style.transform = 'none'
      element.style.webkitTransform = 'none'
      element.style.MozTransform = 'none'
      element.style.msTransform = 'none'
      element.style.OTransform = 'none'
    })
  })
}
